<template>
  <div>
    <b-card class="full-width" style="height: 550px">
      <div slot="header" class="mt-1">
        <strong class="view-header-class">Create Subscription</strong>
      </div>

      <b-row>
        <b-col md="6">
          <label class="ml-5">Subscription Plan </label>
          <eb-select
            label="label"
            class="w-75 ml-5"
            :options="subscriptionOptions"
            v-model="selectPlan"
            placeholder="Select Subscription Plan"
          ></eb-select>
        </b-col>

        <b-col md="6">
          <label> Plan Details </label>
          <c-input
            type="text"
            class="w-75"
            inputId="details"
            readonly
            :value="planDetails"
            lableText=""
          />
        </b-col>
      </b-row>
      <br />
      <b-row>
        <b-col md="6">
          <!-- <v-radio-group v-model="selected" row class="ml-5">
                <v-radio  color="primary" label="Price Override" value="price">
                  <template v-slot:label>
                    <div class="mt-1">Price Override</div>
                  </template>
                </v-radio>
                <v-radio
                  color="primary"
                  label="Discount Percent"
                  value="discount"
                >
                  <template v-slot:label>
                    <div class="mt-1">Discount Percent</div>
                  </template>
                </v-radio>
              </v-radio-group> -->
          <b-form-group class="ml-5">
            <b-form-radio-group id="radio-group-2" v-model="selected">
              <b-form-radio size="lg" value="price"
                ><span style="margin: 13px; font-size: 16px"
                  >Price Override</span
                ></b-form-radio
              >
              <b-form-radio size="lg" value="discount"
                ><span style="margin: 13px; font-size: 16px"
                  >Discount Percent</span
                ></b-form-radio
              >
            </b-form-radio-group>
          </b-form-group>
          <b-col>
            <b-row md="6">
              <strong class="ml-5">Activation Date</strong>
              <b-col class="ml-5" md="5">
                <b-input
                  id="activation-date"
                  type="date"
                  v-model="activationDate"
                ></b-input>
              </b-col>
            </b-row>
          </b-col>
        </b-col>
        <b-col md="6">
          <c-input
            v-if="selected == 'price'"
            inputType="number"
            class="w-75"
            :inputId="`price`"
            v-model="takePriceInput"
            lableText="Price Override"
          />
          <c-input
            v-if="selected == 'discount'"
            inputType="number"
            class="w-75"
            :inputId="`discount`"
            v-model="takeDiscountInput"
            lableText="Discount Percent"
          />
        </b-col>
      </b-row>
      <div class="text-center mt-4">
        <b-button
          btn-special="primary3"
          class="footer-bottons-class mr-5"
          @click="assignSubscription()"
          size="lg"
        >
          Save
        </b-button>
      </div>
    </b-card>
  </div>
</template>
<script>
import ebSelect from "@/components/FormElements/Select";
import cInput from "@/components/Common/CustomInput";
import { mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "CreateSubscription",
  components: {
    ebSelect,
    cInput,
  },
  data() {
    return {
      selectPlan: null,
      selected: null,
      takePriceInput: "",
      takeDiscountInput: "",
      subscriptionOptions: [],
      activationDate: "",
    };
  },
  computed: {
    ...mapGetters({
      subscriptionList: "subscription/GetSubscriptionList",
      partnerAllData: "partner/GetPartnerData",
    }),
    planDetails() {
      if (this.selectPlan) {
        if (this.selectPlan.value.pricing.uom == "OCCURRENCE") {
          return (
            "PRICE : " +
            this.selectPlan.value.pricing.cadence +
            " " +
            this.selectPlan.value.pricing.currency +
            " " +
            this.selectPlan.value.pricing.price
          );
        } else if (
          this.selectPlan.value.pricing.cadence == "EVENT" &&
          this.selectPlan.value.pricing.eventType == "ORDER_FULFILLED"
        ) {
          return (
            "PRICE : " +
            this.selectPlan.value.pricing.price * 100 +
            "%" +
            " OF ORDER " +
            this.selectPlan.value.pricing.uom
          );
        } else if (
          this.selectPlan.value.pricing.cadence == "EVENT" &&
          this.selectPlan.value.pricing.eventType == "DELIVERY_CHARGE"
        ) {
          return (
            "PRICE : " +
            this.selectPlan.value.pricing.price * 100 +
            "%" +
            " OF ORDER " +
            this.selectPlan.value.pricing.uom
          );
        }
      } else {
        return null;
      }
    },
  },
  methods: {
    assignSubscription() {
      if (this.selectPlan) {
        let payload = {
          user: this.$route.params.id,
          discount: "",
          discountType: "",
          plan: this.selectPlan.value._id,
          activationDate: moment(this.activationDate).format("DD/MM/YYYY"),
        };

        if (this.selected == "price") {
          payload.discount = this.takePriceInput;
          payload.discountType = "PRICE";
        } else if (this.selected == "discount") {
          payload.discount = this.takeDiscountInput;
          payload.discountType = "PERCENTAGE";
        } else {
          delete payload.discount;
          delete payload.discountType;
        }

        this.$store
          .dispatch("subscription/assignSubscriptionList", payload)
          .then(result => {
            console.log("result", result);

            this.$swal({
              title: "Added",
              text: "Subscription Plan Assigned Successfully!",
              type: "success",
            });
            this.$router.push({
              name: "view-subscription",
              params: { id: this.$route.params.id },
            });
          })
          .catch(err => {
            console.log("err", err);
            this.$swal({
              title: "Sorry",
              text: "Unable to Assign Subscription Plan",
              type: "error",
            });
          });
      } else {
        this.$swal({
          title: "Failed",
          text: "Opps !!!!...Select Plan First",
          type: "error",
        });
      }
    },
  },
  async mounted() {
    // this.activationDate=moment(this.activationDate).format("yyyy-MM-DD");
    let allOptions = [];
    this.subscriptionList.forEach(element => {
      allOptions.push({ label: element.planName, value: element });
    });
    this.subscriptionOptions = allOptions;
  },
};
</script>
<style>
[btn-special="primary3"] {
  border: 0px;
  font-weight: 500;
  letter-spacing: 1px;
  font-size: medium;
  font-family: "Lato";
  border-radius: 0px;
  height: 39px;
  width: 132px;
  background-color: #727cf5;
  color: white;
}

/* .vs__dropdown-toggle {
  cursor: pointer !important;
  border: 1px solid rgb(222, 226, 230) !important;
  border-radius: 0px !important;
  height: 40px;
} */
.custom-control-label::after {
  position: absolute;
  top: 0.15625rem;
  left: -1.5rem;
  display: block;
  width: 1.4rem;
  height: 1.4rem;
  content: "";
  background: no-repeat 50%/50% 50%;
}
.custom-control-label::before {
  position: absolute;
  top: 0.15625rem;
  left: -1.5rem;
  display: block;
  width: 1.4rem;
  height: 1.4rem;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: #000000 solid 2px;
}
</style>
